<template>
  <div class="modal-body add-modal">
    <div class="modal-body__header">
      <span class="modal-body__title">Добавить контент</span>
      <button class="modal-body__close" type="button" @click="$emit('close')">
        <Icon category="system" class="icon" name="close-line" />
      </button>
    </div>
    <div class="modal-body__content">
      <ul class="add-modal__list">
        <li v-for="(link, i) in list.filter((l) => canShowLink(l.allowedRoles))" :key="i">
          <router-link :to="link.route">{{ link.title }}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/IconComponent.vue";

export default {
  name: "AddModal",
  components: { Icon },
  data() {
    return {
      list: [
        {
          route: {
            name: "act",
          },
          title: "Документ",
          allowedRoles: ["admin", "super-admin"],
        },
        {
          route: {
            name: "activity",
          },
          title: "Деятельность",
          allowedRoles: ["admin"],
        },
        {
          route: {
            name: "banner",
          },
          title: "Баннер",
          allowedRoles: ["admin", "portal-admin"],
        },
        {
          route: {
            name: "category",
          },
          title: "Категория новости",
          allowedRoles: ["admin", "super-admin"],
        },
        {
          route: {
            name: "subdepartmentcategory",
          },
          title: "Категория подведомства",
          allowedRoles: ["admin"],
        },
        {
          route: {
            name: "documenttype",
          },
          title: "Тип документа",
          allowedRoles: ["admin", "super-admin"],
        },
        {
          route: {
            name: "faq",
          },
          title: "Вопрос-ответ",
          allowedRoles: ["admin"],
        },
        {
          route: {
            name: "link",
          },
          title: "Полезная ссылка",
          allowedRoles: ["admin"],
        },
        {
          route: {
            name: "news",
          },
          title: "Новость",
          allowedRoles: ["admin", "super-admin", "sub-department-admin"],
        },
        {
          route: {
            name: "service",
          },
          title: "Услуга",
          allowedRoles: ["sub-department-admin"],
        },
        {
          route: {
            name: "section",
          },
          title: "Отдел",
          allowedRoles: ["admin"],
        },
        {
          route: {
            name: "post",
          },
          title: "Должность",
          allowedRoles: ["admin"],
        },
        {
          route: {
            name: "subdepartment",
          },
          title: "Подведомство",
          allowedRoles: ["admin"],
        },
        {
          route: {
            name: "division",
          },
          title: "Подразделение",
          allowedRoles: ["admin"],
        },
        {
          route: {
            name: "worker",
          },
          title: "Должностное лицо",
          allowedRoles: ["admin"],
        },
        {
          route: {
            name: "department",
          },
          title: "Министерство",
          allowedRoles: ["super-admin", "portal-admin"],
        },
      ],
    };
  },
  methods: {
    canShowLink(roles) {
      if (window.user && window.user.roles) {
        return roles.some((r) => window.user.roles.map((r) => r.name).includes(r));
      }
      return false;
    },
  },
};
</script>

<style lang="stylus">
@import "~@/styles/global/colors.styl"
.add-modal {
  &__list {
    display grid
    width 100%

    li {
      display flex
      width 100%

      &:not(:last-child) {
        border-bottom 1px solid rgba($dark, .2)
      }

      a {
        width 100%
        padding 5px 15px
        color $dark
        font-size 1em

        &:hover {
          background rgba($main_color, .2)
        }
      }
    }
  }
}
</style>
